import maplibregl from 'maplibre-gl';
import _ from 'underscore';
import {kml} from "@tmcw/togeojson";

(function ($) {
	'use strict';

	$.fn.storymap = function (options) {

		let breakpointPos = '33.333%';

		if (window.matchMedia("(max-width: 1000px)").matches) {
			breakpointPos = '50%';
		}

		let defaults = {
			selector: '[data-place]',
			breakpointPos: breakpointPos,


			createMap: function () {
				let markers = options.markers;

				const map = new maplibregl.Map({
					container: options.id,
					style: 'https://api.maptiler.com/maps/voyager/style.json?key=kmG8seuQ8f0lgHQVDrPu',
					center: [2.5558363, 46.4215449],
					zoom: 11,
					interactive: false
				});

				if (options.kml) {
					fetch(options.kml)
						.then(function (response) {
							return response.text();
						})
						.then(function (xml) {
							const kmlData = kml(new DOMParser().parseFromString(xml, "text/xml"));
							map.on('load', function () {
								map.addSource('route', {
									'type': 'geojson',
									'data': {
										'type': 'Feature',
										'properties': {},
										'geometry': {
											'type': 'Polygon',
											'coordinates': [
												kmlData.features[0].geometry.coordinates
											]
										}
									}
								});
								map.addLayer({
									'id': 'route',
									'type': 'line',
									'source': 'route',
									'layout': {
										'line-join': 'round',
										'line-cap': 'round'
									},
									'paint': {
										'line-color': '#3faca3',
										'line-width': 3
									}
								});
							});
						});
				}

				let bounds = new maplibregl.LngLatBounds();
				let i = 0;

				// Markers
				for (let key in options.markers) {
					i = i + 1;

					let newMarker = document.createElement('span');
					let newContent = document.createTextNode(i);
					newMarker.className = 'marker';
					newMarker.setAttribute('data-marker', i);
					newMarker.appendChild(newContent);

					let marker = new maplibregl.Marker(newMarker).setLngLat([markers[key].long, markers[key].lat]).addTo(map);

					bounds.extend(
						[
							markers[key].long,
							markers[key].lat,
						]
					);

					// Markers POI
					if (markers[key].poi != '') {
						let markerPoi = markers[key].poi;

						for (let keyPoi in markerPoi) {
							let newMarker = document.createElement('span');
							newMarker.className = 'markerPoi';
							newMarker.setAttribute('data-poi-marker', i);
							newMarker.setAttribute('data-poi-marker-id', markerPoi[keyPoi].id);
							let popupHtml = $('[id="' + markerPoi[keyPoi].id + '"][data-id="wpiris-interest-points-item-infobox"]').html().replace("data-src", "src");
							let popup = new maplibregl.Popup({offset: 25}).setHTML(popupHtml);

							if (window.matchMedia("(max-width: 1000px)").matches) {
								let marker = new maplibregl.Marker(newMarker).setLngLat([markerPoi[keyPoi].long, markerPoi[keyPoi].lat]).addTo(map);
							} else {
								let marker = new maplibregl.Marker(newMarker).setLngLat([markerPoi[keyPoi].long, markerPoi[keyPoi].lat]).setPopup(popup).addTo(map);
							}
							bounds.extend(
								[
									markerPoi[keyPoi].long,
									markerPoi[keyPoi].lat,
								]
							);
						}
					}
				}

				map.fitBounds(bounds, {padding: 100});
				$(document).trigger('roadtrip-map-load')
				return map;
			},
		};

		let settings = $.extend(defaults, options);

		const arrayPositionStepLeft = [];
		const arrayPositionStepTop = [];
		$(options.current_block.find('[data-id="road-trip-sidebar-step-item"]')).each(function (i) {
			arrayPositionStepLeft[i + 1] = $(this).offset().left;
			arrayPositionStepTop[i + 1] = $(this).position().top;
		})

		if (typeof (Map) === 'undefined') {
			throw new Error('Storymap requires Maplibre');
		}
		if (typeof (_) === 'undefined') {
			throw new Error('Storymap requires underscore.js');
		}

		function getDistanceToTop(elem, top) {
			let docViewTop = $(window).scrollTop();

			let elemTop = $(elem).offset().top;

			let dist = elemTop - docViewTop;

			let d1 = top - dist;

			if (d1 < 0) {
				return elemTop + $(elem).outerHeight();
			}
			return d1;
		}

		function highlightTopPara(paragraphs, top) {

			let distances = _.map(paragraphs, function (element) {
				let dist = getDistanceToTop(element, top);
				return {
					el: $(element),
					distance: dist,
				};
			});

			let closest = _.min(distances, function (dist) {
				return dist.distance;
			});


			_.each(paragraphs, function (element) {
				let paragraph = $(element);
				if (paragraph[0] !== closest.el[0]) {
					paragraph.trigger('notviewing');
				}
			});

			if (!closest.el.hasClass('viewing')) {
				closest.el.trigger('viewing');
			}
		}

		function watchHighlight(element, searchfor, top) {
			let paragraphs = element.find(searchfor);
			highlightTopPara(paragraphs, top);
			$(window).scroll(function () {
				highlightTopPara(paragraphs, top);
			});
		}

		function hoverPoi() {
			$('[data-id="wpiris-interest-points-item"]').hover(function (e) {
					let id = $(this).attr('id');
					$('[data-poi-marker-id="' + id + '"]').addClass('hover');
				}, function (e) {
					$('[data-poi-marker-id]').removeClass('hover');
				}
			)
		}

		let makeStoryMap = function (element, markers) {

			let topElem = $('<div class="breakpoint-current"></div>')
				.css('top', settings.breakpointPos)
				.css('position', 'fixed');
			$('body').append(topElem);

			let top = topElem.offset().top - $(window).scrollTop();

			let searchfor = settings.selector;

			let paragraphs = element.find(searchfor);

			watchHighlight(element, searchfor, top);

			let map = settings.createMap();
			let initPoint = map.getCenter();
			let initZoom = map.getZoom();

			function showMapView(key) {

				let bounds = new maplibregl.LngLatBounds();

				// Gloabl view
				if (key === undefined) {
					map.flyTo(
						{
							center: initPoint,
							zoom: initZoom
						}
					);

					// Detail Step
				} else if (markers[key]) {

					let marker = markers[key];

					$("[data-marker]").removeClass('active');
					$("[data-poi-marker]").removeClass('active');
					$("[data-marker='" + key + "']").addClass('active');
					$("[data-poi-marker='" + key + "']").addClass('active');

					map.flyTo(
						{
							center: [
								marker.long,
								marker.lat,
							],
							pitch: marker.pitch,
							bearing: marker.bearing,
							zoom: marker.zoom
						}
					);

				}
			}

			function changeValue(element, value) {
				const replace = options.current_block.find(element);
				$(replace).html(value);
			}

			function activeStep(key) {
				const roadTripStepItem = options.current_block.find('[data-id="road-trip-sidebar-step-item"][data-value="' + key + '"]');
				const left = arrayPositionStepLeft[key];
				const top = arrayPositionStepTop[key];
				const width = $(window).outerWidth();
				const height = $('[data-id="road-trip-map-sidebar"]').outerHeight();
				options.current_block.find('[data-id="road-trip-sidebar-step-item"]').removeClass('active');
				roadTripStepItem.addClass('active');
				if (window.matchMedia("(max-width: 1000px)").matches) {
					if (left > width) {
						const swift = width - left;
						$('[data-id="road-trip-sidebar-step-list"]').css('transform', 'translateX(' + swift + 'px)');
					} else {
						$('[data-id="road-trip-sidebar-step-list"]').css('transform', 'none');
					}
				} else {
					if (top > height) {
						const swift = height - top;
						$('[data-id="road-trip-sidebar-step-list"]').css('transform', 'translateY(' + swift + 'px)');
					} else {
						$('[data-id="road-trip-sidebar-step-list"]').css('transform', 'none');
					}
				}
			}

			function triggerActiveStep() {
				const selector = '[data-id="road-trip-sidebar-step-item"], [data-marker]';

				options.current_block.on('click', selector, function (e) {
					e.preventDefault();
					let step = '';

					if ($(this).hasClass('marker')) {
						step = $(this).attr('data-marker');
					} else {
						step = $(this).attr('data-value');
					}
					let shift = 0;

					if (window.matchMedia("(max-width: 1000px)").matches) {
						shift = options.current_block.find('[data-id="road-trip-map-container"]').outerHeight() + options.current_block.find('[data-id="road-trip-map-sidebar"]').outerHeight();
					} else {
						shift = options.current_block.find('[data-id="road-trip-map-topbar"]').outerHeight();
					}

					const scrollTop = options.current_block.find('[data-step="' + step + '"]').offset().top - shift;


					$('html, body').animate({
						scrollTop: scrollTop
					});
				})
			}


			$(document).bind('roadtrip-map-load', triggerActiveStep);
			triggerActiveStep();
			paragraphs.on('viewing', function () {
				$(this).addClass('viewing');
				showMapView($(this).data('step'));
				if (window.matchMedia("(min-width: 1000px)").matches) {
					changeValue('[data-id="road-trip-map-topbar-title"]', $(this).find('[data-id="wpiris-step-title"]').html());
					changeValue('[data-id="road-trip-map-topbar-step-number"]', $(this).data('step'));
					changeValue('[data-id="road-trip-map-topbar-metas"]', $(this).find('[data-id="wpiris-step-metas"]').html());
				}
				activeStep($(this).data('step'));
			});

			paragraphs.on('notviewing', function () {
				$(this).removeClass('viewing');
			});

		};

		makeStoryMap(this, settings.markers);
		hoverPoi();
		return this;
	};

}(jQuery));
